import { createApp } from 'vue'
import Home from './views/Home.vue'
import './style.css'

const app = createApp(Home)

app.mount('#app')
